export const scope = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 9V6.06189C9.38128 6.51314 6.51314 9.38128 6.06189 13H9V15H6.06189C6.51314 18.6187 9.38128 21.4869 13 21.9381V19H15V21.9381C18.6187 21.4869 21.4869 18.6187 21.9381 15H19V13H21.9381C21.4869 9.38128 18.6187 6.51314 15 6.06189V9H13ZM4.04938 15C4.51844 19.7244 8.27558 23.4816 13 23.9506V27H15V23.9506C19.7244 23.4816 23.4816 19.7244 23.9506 15H27V13H23.9506C23.4816 8.27558 19.7244 4.51844 15 4.04938V1H13V4.04938C8.27558 4.51844 4.51844 8.27558 4.04938 13H1V15H4.04938Z"
    fill="currentColor"
  />
);
